import * as yup from 'yup'

const schema = yup.object().shape({
  entity: yup.string().required('Campo obrigatório'),
  entity_translated: yup.string().required('Campo obrigatório'),
})

export { schema }
